import React from 'react';

export default function FiltroDataDinamico({
  tipoData,
  setTipoData,
  dataInicio,
  setDataInicio,
  dataFim,
  setDataFim,
  erroData
}) {
  return (
    <div className="flex gap-2 items-end">
      <div className="flex flex-col w-[168px]">
        <label className="text-[10px] font-bold text-blue-500 mb-0.5 ml-1 tracking-wider drop-shadow">
          🪐 Filtro Galáctico
        </label>
        <div className="relative">
          <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-blue-400 text-[11px] pointer-events-none">
            🔭
          </span>
          <select
            value={tipoData}
            onChange={e => setTipoData(e.target.value)}
            className="pl-7 pr-1 h-8 rounded-xl border-2 border-blue-400 text-blue-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-pink-200 transition-all duration-200 w-full text-[11px]"
          >
            <option value="">Selecione o Filtro</option>
            <option value="data_lead">Data Lead</option>
            <option value="criado_em">Data Lançamento</option>
            <option value="data_agendamento">Data Agendamento</option>
            <option value="data_recebimento">Data Recebimento</option>
          </select>
        </div>
      </div>
      <div className="flex flex-col w-[130px]">
        <label className="text-[10px] font-bold text-purple-500 mb-0.5 ml-1 tracking-wider drop-shadow">
          🛸 De
        </label>
        <div className="relative">
          <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-purple-400 text-[11px] pointer-events-none">
            📅
          </span>
          <input
            type="date"
            value={dataInicio}
            onChange={e => setDataInicio(e.target.value)}
            className="pl-7 pr-1 h-8 rounded-xl border-2 border-purple-400 text-purple-700 font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-blue-200 transition-all duration-200 w-full text-[11px]"
          />
        </div>
      </div>
      <div className="flex flex-col w-[130px]">
        <label className="text-[10px] font-bold text-pink-500 mb-0.5 ml-1 tracking-wider drop-shadow">
          🚀 Até
        </label>
        <div className="relative">
          <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-pink-400 text-[11px] pointer-events-none">
            📅
          </span>
          <input
            type="date"
            value={dataFim}
            onChange={e => setDataFim(e.target.value)}
            className={`pl-7 pr-1 h-8 rounded-xl border-2 font-semibold shadow-md w-full text-[11px] transition-all duration-200 focus:outline-none ${
              erroData
                ? 'border-red-400 focus:ring-2 focus:ring-red-200 text-red-600'
                : 'border-pink-400 focus:ring-2 focus:ring-blue-200 text-pink-700'
            }`}
          />
        </div>
        {erroData && (
          <span className="text-[9px] text-red-500 mt-0.5 font-semibold">
            A Data Fim não pode ser menor que a Data Início
          </span>
        )}
      </div>
    </div>
  );
}